module.exports = __webpack_public_path__ + "img/public.e2c4de98.svg";